import BootstrapColorService from "../../Services/Shared/BootstrapColor.service";
export default class OpportunityDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { pipelineEntryDate: new Date(json.pipelineEntryDate), stageUpdatedDate: new Date(json.stageUpdatedDate) });
    }
    static getProgressBars({ stagesInPipeline, opportunityVisitedStageIds, currentStageId, }) {
        return stagesInPipeline.map((stage) => {
            let color = BootstrapColorService.Secondary;
            let titlePrefix = "";
            if (currentStageId === stage.id) {
                // @ts-expect-error - TS2322 - Type '"#28a745"' is not assignable to type '"#6c757d"'.
                color = BootstrapColorService.Success;
                titlePrefix = "Current: ";
            }
            else if (opportunityVisitedStageIds === null || opportunityVisitedStageIds === void 0 ? void 0 : opportunityVisitedStageIds.includes(stage.id)) {
                // @ts-expect-error - TS2322 - Type '"#007bff"' is not assignable to type '"#6c757d"'.
                color = BootstrapColorService.Primary;
                titlePrefix = "Visited: ";
            }
            return {
                progress: 1 / stagesInPipeline.length,
                color,
                title: titlePrefix + stage.name,
                label: stage.name,
            };
        });
    }
}
